import { EventItem, PathData, RaceDetails } from '../../data-types/sports/sportsInterfaces';
import { ResetState } from './stateTypes';

export type SportsbookActionType =
  | ResetState
  | SetDetailedEvent
  | SetRace
  | LoadingEvents
  | IsSuperchargedBetTickerVisible
  | TriggerSportsbookResubscriptions
  | SetLastSeenSportPage;

export const SET_DETAILED_EVENT = 'SET_DETAILED_EVENT';
export const SET_RACE = 'SET_RACE';
export const LOADING_EVENTS = 'LOADING_EVENTS';
export const SET_IS_SUPERCHARGED_BET_TICKER_VISIBLE = 'SET_IS_SUPERCHARGED_BET_TICKER_VISIBLE';
export const SET_TRIGGER_SPORRTSBOOK_RESUBSCRIPTIONS = 'SET_TRIGGER_SPORRTSBOOK_RESUBSCRIPTIONS';
export const SET_LAST_SEEN_SPORT_PAGE = 'SET_LAST_SEEN_SPORT_PAGE';

export interface SportsbookState {
  detailedEvent: EventItem | undefined;
  race: RaceDetails | undefined;
  loadingEvents: boolean;
  isSuperchargedTickerVisible: boolean;
  triggerSportsbookResubscriptions: boolean;
  lastSeenSportPage: PathData | undefined;
}

interface SetDetailedEvent {
  type: typeof SET_DETAILED_EVENT;
  meta: EventItem | undefined;
}

interface SetRace {
  type: typeof SET_RACE;
  meta: RaceDetails | undefined;
}

interface LoadingEvents {
  type: typeof LOADING_EVENTS;
  meta: boolean;
}

interface IsSuperchargedBetTickerVisible {
  type: typeof SET_IS_SUPERCHARGED_BET_TICKER_VISIBLE;
  meta: boolean;
}

interface TriggerSportsbookResubscriptions {
  type: typeof SET_TRIGGER_SPORRTSBOOK_RESUBSCRIPTIONS;
  meta: boolean;
}

interface SetLastSeenSportPage {
  type: typeof SET_LAST_SEEN_SPORT_PAGE;
  meta: PathData | undefined;
}
